/* eslint-disable  react/prop-types */

import React from 'react';

const ChatBubbleIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.0861 27.2418C22.2891 27.137 22.522 27.1048 22.7458 27.1506L28.8219 28.3956L27.5201 22.4634C27.4692 22.2315 27.5025 21.9891 27.614 21.7795C28.5804 19.9626 29.1284 17.8888 29.1284 15.6841C29.1284 8.50438 23.3081 2.68408 16.1284 2.68408C8.94872 2.68408 3.12842 8.50438 3.12842 15.6841C3.12842 22.8638 8.94872 28.6841 16.1284 28.6841C18.2777 28.6841 20.3025 28.1633 22.0861 27.2418Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.98242 13.7754H21.1452"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9.98242 18.8096H16.9592"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ChatBubbleIcon;
